import React, { useEffect } from 'react';
import { SimpleGrid, Container, Heading, Box } from '@chakra-ui/react';
import { useDispatch, useSelector } from 'react-redux';
import MarketplaceCard from './components/MarketplaceCard';
import { getMarketplacesApi } from 'features/marketplaces/marketplaces.api';
import { useColors } from './components/colors';

import amazonLogo from 'assets/img/marketplaces/amazon.png';
import ebayLogo from 'assets/img/marketplaces/ebay.png';
import walmartLogo from 'assets/img/marketplaces/walmart.png';

const marketplacesLogos = {
  amazon: amazonLogo,
  ebay: ebayLogo,
  walmart: walmartLogo,
};

const getMarketplaceData = (marketplace) => {
  const configs = marketplace.configurations || [];

  const clientIdConfig = configs.find((c) => c.key === 'clientId');
  const clientSecretConfig = configs.find((c) => c.key === 'clientSecret');
  const runameConfig = configs.find((c) => c.key === 'runame');

  const clientId = clientIdConfig?.value || '';
  const clientSecret = clientSecretConfig?.value || '';
  const runame = runameConfig?.value || '';

  const isConfigValid = Boolean(clientId && clientSecret);

  return {
    id: marketplace._id,
    logo: marketplacesLogos[marketplace.name.toLowerCase()],
    name: marketplace.name,
    storeCount: marketplace.storeCount,
    clientId,
    clientSecret,
    runame,
    isConfigValid,
  };
};

const Marketplaces = () => {
  const dispatch = useDispatch();
  const { marketplaces } = useSelector((state) => state.marketplaces);
  const { textColor } = useColors();

  useEffect(() => {
    dispatch(getMarketplacesApi({ page: 1, limit: 10 }));
  }, [dispatch]);

  return (
    <Box px={{ base: 4, md: 10 }} py={{ base: 6, md: 8 }} mt="50px">
      <Heading as="h1" size="xl" mb={6} color={textColor}>
        Overview
      </Heading>
      <SimpleGrid columns={{ base: 1, md: 2 }} spacing={8}>
        {Array.isArray(marketplaces) &&
          marketplaces.map((marketplace) => (
            <MarketplaceCard key={marketplace.id} {...getMarketplaceData(marketplace)} />
          ))}
      </SimpleGrid>
    </Box>
  );
};

export default Marketplaces;
